import { render, staticRenderFns } from "./projectDepartmentAssessment.vue?vue&type=template&id=9dba6e0c&scoped=true&"
import script from "./projectDepartmentAssessment.vue?vue&type=script&lang=js&"
export * from "./projectDepartmentAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dba6e0c",
  null
  
)

export default component.exports